<template>
  <RevButton
    :aria-label="alternativeLabel"
    full-width="responsive"
    target="_blank"
    :to="url"
    variant="primary"
  >
    {{ i18n(translations.pdfLink) }}
  </RevButton>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { Pdf } from '@backmarket/http-api/src/api-specs-content'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'

import translations from './PDFLink.translations'

const props = defineProps<Pdf>()

const i18n = useI18n()

const alternativeLabel = computed(
  () => `${props.title} ${i18n(translations.pdfLink)}`,
)
</script>
